import Swiper, { Pagination, Parallax } from 'swiper';
import { mouse } from './canvas';

Swiper.use([Pagination, Parallax]);

export function setupSwipers() {
    const swipers = document.querySelectorAll('[data-action="swiper"]');

    swipers.forEach(swiperContainer => {
        const swiper = new Swiper(swiperContainer, {
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar'
            },
            slidesPerView: 'auto', // Slide sizes are controlled with css - not here
            speed: 500,
            parallax: true,
            centeredSlides: false,
        });

        // By listening to touchmove on swiper, we can move our custom cursor.
        // We can't move it with 'mousemove' on document.body as swiper somehow overrules this.
        swiper.on('touchMove',function(swiper,event) {
            mouse.x = event.clientX;
            mouse.y = event.clientY;
        });
    });
}
